import React, { useMemo, ReactElement, ChangeEvent } from 'react';
import { FieldError } from 'react-hook-form';
import { Container, Label, StyledControl, ErrorMessage } from '@components/Form/Control/styles';

export enum CONTROL_TYPE {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
}

type Props = {
  type?: CONTROL_TYPE;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  label: string | ReactElement;
  name: string;
  value: string | boolean;
  error?: FieldError | undefined;
  htmlLabel?: boolean;
  checked?: boolean | undefined;
  centered?: boolean;
};

function Control({
  centered = false,
  type = CONTROL_TYPE.RADIO,
  label,
  name,
  error,
  onChange,
  value,
  htmlLabel = false,
  checked = false,
}: Props) {
  const inputId = useMemo(() => `control_${name}-${type}-${String(value)}`, [name, type, value]);

  return (
    <Container className="custom-control" centered={!!centered}>
      <StyledControl
        name={name}
        id={inputId}
        type={type}
        value={String(value)}
        onChange={onChange}
        className={error && 'invalid'}
        checked={checked}
      />

      {label !== '' && !htmlLabel && (
        <Label htmlFor={inputId} withError={!!error}>
          {label}
        </Label>
      )}
      {label !== '' && htmlLabel && (
        <Label htmlFor={inputId} withError={!!error} dangerouslySetInnerHTML={{ __html: label as string }} />
      )}
      {error && <ErrorMessage>{error.message}</ErrorMessage>}
    </Container>
  );
}

export default Control;
